import * as React from 'react';
import classnames from 'classnames';
import { motion } from 'motion/react';
import useOnClickOutside from 'use-onclickoutside';
import { ButtonDropdownButton } from './components/ButtonDropdownButton/ButtonDropdownButton.js';
import { ButtonDropdownContent } from './components/ButtonDropdownContent/ButtonDropdownContent.js';
import { ButtonDropdownGridCell } from './components/ButtonDropdownGridCell/ButtonDropdownGridCell.js';
import { ButtonDropdownGridRow } from './components/ButtonDropdownGridRow/ButtonDropdownGridRow.js';
import { ButtonDropdownInteractiveWrapper } from './components/ButtonDropdownInteractiveWrapper/ButtonDropdownInteractiveWrapper.js';
import { ButtonDropdownEmptyOption } from './components/ButtonDropdownOption/ButtonDropdownEmptyOption.js';
import { ButtonDropdownOption } from './components/ButtonDropdownOption/ButtonDropdownOption.js';
import { ButtonDropdownSelect } from './components/ButtonDropdownSelect/ButtonDropdownSelect.js';
import { ButtonDropdownProvider } from './context/ButtonDropdownContext.js';

/**
 * This is a customizable dropdown component that supports two styles:
 * 1. **Menu/Filter**: Ideal for menu-like interactions.
 * 2. **Form Element**: Functions similarly to a select field.
 *
 * Please check the readme for examples on how to use this composable dropdown component.
 */ const ButtonDropdown = ({ 'aria-label': ariaLabel , 'data-t': dataT , className , isDisabled , isInvalid , offset , placement , isRequired , children , onChange , value , cols , itemSizes , orientation , loop , focusItemOnHover ,  })=>{
    const [isOpen, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef(null);
    useOnClickOutside(dropdownRef, ()=>{
        setIsOpen(false);
    });
    return /*#__PURE__*/ React.createElement(ButtonDropdownProvider, {
        "aria-label": ariaLabel,
        isDisabled: isDisabled,
        isInvalid: isInvalid,
        isOpen: isOpen,
        offset: offset,
        placement: placement,
        isRequired: isRequired,
        setIsOpen: setIsOpen,
        onChange: onChange,
        value: value,
        cols: cols,
        orientation: orientation,
        itemSizes: itemSizes,
        loop: loop,
        focusItemOnHover: focusItemOnHover
    }, /*#__PURE__*/ React.createElement(motion.div, {
        ref: dropdownRef,
        animate: isOpen ? 'button-dropdown--is-open' : 'button-dropdown--is-closed',
        className: classnames('button-dropdown', className),
        "data-t": dataT
    }, children));
};
ButtonDropdown.Button = ButtonDropdownButton;
ButtonDropdown.Content = ButtonDropdownContent;
ButtonDropdown.EmptyOption = ButtonDropdownEmptyOption;
ButtonDropdown.GridCell = ButtonDropdownGridCell;
ButtonDropdown.GridRow = ButtonDropdownGridRow;
ButtonDropdown.InteractiveWrapper = ButtonDropdownInteractiveWrapper;
ButtonDropdown.Option = ButtonDropdownOption;
ButtonDropdown.Select = ButtonDropdownSelect;

export { ButtonDropdown, ButtonDropdown as default };
//# sourceMappingURL=ButtonDropdown.js.map
